export default "__VITE_ASSET__CWDCpH4D__"